export const imgsapiUrl = 'https://play.vqmjc.cc/static/'
// export const imgsapiUrl = 'http://192.168.50.18:8000/static/'
export const apiUrl = 'https://play.vqmjc.cc/api/'
// export const apiUrl = 'http://192.168.50.18:8000/api/'
